import { render, staticRenderFns } from "./HacizliMalinSatisiIcinTalimatYazilmasiTalepEvrakForm.vue?vue&type=template&id=39b6ccd9"
import script from "./HacizliMalinSatisiIcinTalimatYazilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./HacizliMalinSatisiIcinTalimatYazilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports